// extracted by mini-css-extract-plugin
export default {"customThresholds":"BuildingThresholds_customThresholds__xugIF"};